import { useEffect } from 'react';
import { message } from 'antd';
import { logger } from 'utils/debug';

const usePermissionMessage = (permission) => {
  useEffect(() => {
    if (!permission.hasAllViewPermission) {
      if (process.env.NODE_ENV === 'development') logger('[permission]', permission);
      message.warn('Hacen falta permisos en los catálogos relacionados a este módulo');
    }
  }, []);
};

export default usePermissionMessage;
